import React, { useMemo } from 'react';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import {
  dataGridTextSorter,
  dataGridNumberSorter,
} from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { useYesNoDataGridFilter } from '../../../../common/DataGrid/filters/DataGridFilters.jsx';
import PropTypes from 'prop-types';
import { Spinner } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';

const SlidersTable = ({ sliders, onDelete, onDetailClick }) => {
  const { t } = useTranslation();

  const descriptionTextFilterProps = useDataGridTextFilter('meta_name');
  const urlTextFilterProps = useDataGridTextFilter('target_url');
  const activeBooleanFilterProps = useYesNoDataGridFilter('active');

  const dataGridColumns = useMemo(
    () => [
      {
        title: t('Obrázok'),
        dataIndex: 'image',
        render: (image) => (
          <img
            title={'image'}
            className="banner-list-image"
            src={`${image}`}
            alt="Slider"
          />
        ),
      },
      {
        title: 'URL',
        dataIndex: 'target_url',
        ellipsis: true,
        sorter: dataGridTextSorter('target_url'),
        ...urlTextFilterProps,
      },
      {
        title: t('Popis'),
        dataIndex: 'meta_name',
        ellipsis: true,
        sorter: dataGridTextSorter('meta_name'),
        ...descriptionTextFilterProps,
      },
      {
        title: t('Poradie'),
        dataIndex: 'position',
        sorter: dataGridNumberSorter('position'),
      },
      {
        title: t('Aktívny'),
        dataIndex: 'active',
        ...activeBooleanFilterProps,
      },
    ],
    [t, descriptionTextFilterProps, activeBooleanFilterProps],
  );

  if (!sliders) {
    return <Spinner />;
  }

  return (
    <>
      <DataGrid
        rowKey={(slider) => slider.id}
        columns={dataGridColumns}
        dataSource={sliders || []}
        permissionsBasic={'sliders'}
        uniqueTableId={'sliders-table'}
        onDelete={onDelete}
        onEditClick={onDetailClick}
        onRowClick={onDetailClick}
      />
    </>
  );
};

SlidersTable.propTypes = {
  sliders: PropTypes.array,
  onDelete: PropTypes.func,
  onDetailClick: PropTypes.func,
};

export default SlidersTable;
